const products_on_page = document.getElementById('blog-grid');
const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];

function getNextUrl() {
  return products_on_page?.dataset?.nextUrl || '';
}

function setNextUrl(url) {
  if (products_on_page) products_on_page.dataset.nextUrl = url || '';
}

function updateLoadMoreVisibility() {
  const url = getNextUrl();
  if (!load_more_btn) return;
  load_more_btn.style.display = url ? 'flex' : 'none';
}

async function getNextPage(next_url) {
  try {
    let res = await fetch(next_url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    return await res.text();
  } catch (error) {
    console.log(error);
  }
}

async function loadMoreProducts() {
  const next_url = getNextUrl();
  if (!next_url) return;

  load_more_btn.style.display = 'none';
  load_more_spinner.style.display = 'block';

  let nextPage = await getNextPage(next_url);

  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

  load_more_spinner.style.display = 'none';

  const productgrid = nextPageDoc.getElementById('blog-grid');
  if (!productgrid) return;

  const new_products = productgrid.getElementsByClassName('grid__item');
  const new_url = productgrid.dataset.nextUrl;

  setNextUrl(new_url);

  for (let i = 0; i < new_products.length; i++) {
    products_on_page.appendChild(new_products[i]);
  }

  updateLoadMoreVisibility();
}

// bind click (if not already)
if (load_more_btn) {
  load_more_btn.addEventListener('click', (e) => {
    e.preventDefault();
    loadMoreProducts();
  });
}

// init
updateLoadMoreVisibility();


/*Loadmore Pagination*/
class PaginateLoadmore extends HTMLElement {
  constructor() {
    super();
    this.initLoadMore();
  }
  initLoadMore() {
    this.querySelectorAll('.actions-loadmore').forEach((loadMore) => {
      var _this = this;
        loadMore.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            _this.loadMoreItem(target);
          },
          false
        );
    });
  }
  loadMoreItem(target) {
    const loadMore_url = target.getAttribute('href');
    const _this = this;
    _this.toggleLoading(target);
    fetch(`${loadMore_url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        const parser = new DOMParser();
        const resultNodes = parser.parseFromString(responseText, 'text/html');
        const resultNodesHtml = resultNodes.querySelectorAll(
          '.loadmore-lists .loadmore-item'
        );
        resultNodesHtml.forEach((prodNode) =>
          document.querySelector('.loadmore-lists').appendChild(prodNode)
        );
        const load_more = resultNodes.querySelector('.actions-loadmore');
        document.querySelector('.load-more-bar').innerHTML =
          resultNodes.querySelector('.load-more-bar').innerHTML;
        if (load_more) {
          target.setAttribute('href', load_more.getAttribute('href'));
        } else {
          target.remove();
        }
        _this.toggleLoading(target);
      })
      .catch((error) => {
        throw error;
      });
  }
  toggleLoading(event) {
    if (event) {
      const loader = event.querySelector('.loading__spinner');
      if(loader.classList.contains('hidden')){
        loader.classList.remove('hidden');
      }else{
        loader.classList.add('hidden');
      }
    }
  }
}
customElements.define('loadmore-button', PaginateLoadmore);